import React, { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const navItems = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/programs", label: "Programs" },
  { to: "/community", label: "Community" },
  { to: "/visit", label: "Visit" },
  { to: "/support", label: "Support" },
  { to: "/contact", label: "Contact" },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 transition-colors duration-300 ${
        scrolled ? "bg-[#fdfaf3]/95 backdrop-blur border-b border-[#e9dcc0]" : "bg-[#fdfaf3]"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3 group" aria-label="Van Hanh Monastery home">
            <span className="w-10 h-10 rounded-full bg-[#7a2e1f] text-[#fdfaf3] grid place-items-center font-serif text-xl transition-transform duration-300 group-hover:scale-105">
              ❉
            </span>
            <span className="leading-tight">
              <span className="block font-serif text-xl text-[#3d2817]">Van Hanh Monastery</span>
              <span className="block text-[10px] tracking-[0.25em] uppercase text-[#8a6b3f]">Canberra · Since 1983</span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-8" aria-label="Primary">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `nav-link text-[15px] tracking-wide text-[#3d2817] ${isActive ? "active text-[#7a2e1f]" : "hover:text-[#7a2e1f]"}`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:block">
            <Link to="/support" className="btn-primary text-sm">Support Us</Link>
          </div>

          <button
            className="lg:hidden p-2 -mr-2 text-[#3d2817]"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#e9dcc0] bg-[#fdfaf3]">
          <nav className="px-6 py-4 flex flex-col gap-1" aria-label="Mobile">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `py-3 px-2 text-[#3d2817] border-b border-[#f0e6cf] ${isActive ? "text-[#7a2e1f]" : ""}`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link to="/support" onClick={() => setOpen(false)} className="btn-primary mt-4 justify-center text-sm">Support Us</Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
